import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmsMenuLoginComponent } from '../../../../core/model';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'py-menu-login',
  templateUrl: './menu-login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MenuLoginComponent implements OnInit {
  isAnonymous$: Observable<boolean>;
  hasActiveMenuItem$: Observable<boolean>;

  constructor(
    public component: CmsComponentData<CmsMenuLoginComponent>,
    private authService: AuthService,
    private menuService: MenuService
  ) {}

  ngOnInit() {
    this.isAnonymous$ = this.authService.isUserLoggedIn().pipe(map((s) => !s));
    this.hasActiveMenuItem$ = this.menuService.hasActiveLinkUid();
  }
}
